import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Sort } from 'images/latest'

const SortIcon = ({ color = 'black' }) => (
  <ResponsiveSVG
    width='16px'
    height='16px'
    className='unstyled'
    color={color}
    SVG={Sort}
  />
)

export default SortIcon
